import React from "react";
import { Link, Redirect } from "react-router-dom";
import {useSelector} from "react-redux";
import useAuth from "components/Common/UseAuth";
import Alert from "components/Alert/Alert.js";
import { Action, Store } from "@byhuz/huz-ui-state";

export default function Login(props) {
  const isPasswordError=useSelector(state=>state.default?.isPasswordError||false);

  const [ email, setEmail ] = React.useState("");
  const [ password, setPassword ] = React.useState("");
  const [alertColor, setAlertColor] = React.useState("bg-green-500");  
  const [alertTitle, setAlertTitle] = React.useState("");  
  const [alertMSg, setAlertMSg] = React.useState("");  
  const [showAlert, setShowAlert] = React.useState(false); 

  const {isLoggedIn, login}=useAuth();  

  const showInfo = () => {
    if (showAlert) {
      let response = <Alert title={alertTitle} message={alertMSg} color={alertColor} callback={()=>{
        setShowAlert(false);
      }}/>;
      return response;
    }
    return (<div></div>);
  }

  // Login Function
  const handleSubmit = (e) => {
    e.preventDefault();

    const data = {
      username: email,
      password: password
    }

    login(data);      
  }

  React.useEffect(()=>{      
      if (isPasswordError) {
        Store.dispatch(Action.update("isPasswordError", false));
        setAlertTitle(<div></div>);
        setAlertMSg("Invalid credentials!");
        setAlertColor("bg-red-500");
        setShowAlert(true);  
      }
  },[isPasswordError]);

  if (isLoggedIn){
    console.log("Redirect to Admin");
    return <Redirect to={{
      pathname: '/admin'
    }} />;
  }

  return (    
      <div className="container mx-auto px-4 h-full">
        <div className="flex content-center items-center justify-center h-full">
          <div className="w-full lg:w-4/12 px-4">
            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-gray-300 border-0">
              <div className="rounded-t mb-0 px-6 py-6">
                <div className="text-center mb-3">
                  <h6 className="text-gray-600 text-sm font-bold">
                    Sign in with
                  </h6>
                </div>
                <div className="btn-wrapper text-center">
                  <button
                    className="bg-white active:bg-gray-100 text-gray-800 font-normal px-4 py-2 rounded outline-none focus:outline-none mr-1 mb-1 uppercase shadow hover:shadow-md inline-flex items-center font-bold text-xs ease-linear transition-all duration-150"
                    type="button"
                  >
                    <img
                      alt="MBlink"
                      className="mr-1"
                      src={require("assets/img/logo.png")}
                    />
                                            
                  </button>
                </div>
                <hr className="mt-6 border-b-1 border-gray-400" />
              </div>
              <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                <form>
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Email
                    </label>
                    <input
                      type="email"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder="Email"
                      onChange={e=> setEmail(e.target.value)}
                    />
                  </div>

                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Password
                    </label>
                    <input
                      type="password"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder="Password"
                      onChange={e=> setPassword(e.target.value)}
                    />
                  </div>

                  { showAlert ? showInfo() : null }

                  <div className="text-center mt-6">
                    <button
                      className="bg-gray-900 text-white active:bg-gray-700 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                      type="button" onClick={handleSubmit}
                    >
                      Sign In
                    </button>
                  </div>

                  <div className="text-gray-500 text-center mb-1 font-bold">
                      <Link to="/auth/register" className="text-sm text-gray-500 font-bold">
                          Create new account
                      </Link>
                  </div>                        

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>    
  );
}
